"use client";
import React, { Ref, useCallback, useEffect, useRef } from "react";
import Sdk from "casdoor-js-sdk";
import casdoorConfig from "@/config/casdoorConfig";
function useCasdoor(
    type: "connect_social" | "email_authen" | "login"
): [
    React.MutableRefObject<Sdk>,
    (state: string, provider?: string, connect_socials?: string) => void,
    (onSuccess: (data?: any) => void, onError: (error?: any) => void, onFinally: () => void) => void
] {
    const state = useRef<any>();

    const signRedirect = (currentState: string, provider: string = "", connect_socials: string = "") => {
        state.current.signin_redirect({ state: currentState, connect_socials, provider_custom: provider });
    };
    const getInfoCasdoor = (onSuccess: (data?: any) => void, onError: (error?: any) => void, onFinally: () => void) => {
        state.current
            ?.exchangeForAccessToken()
            .then((res: any) => {
                if (res && res.access_token) {
                    return res;
                }
                throw new Error("Failed to get access token");
            })
            .then(onSuccess)
            .catch(onError)
            .finally(onFinally);
    };

    useEffect(() => {
        state.current = new Sdk(casdoorConfig(type));
    }, [type]);
    return [state, signRedirect, getInfoCasdoor];
}

export default useCasdoor;
